export default __webpack_public_path__ + "static/media/fileImage.6ff1a105.svg";